<template>
	<li class="c-toc__item menu-item" :key="text">
		<a :href="`#toc-content-${index}`" class="c-toc__link" @click="handleClick">{{ text }}</a>
	</li>
</template>

<script>
import Vue from "vue";
import scrollSpy, { Easing } from "vue2-scrollspy";

Vue.use(scrollSpy, {
	easing: Easing.Cubic.In
});

export default {
	name: "VTocLink",
	components: {
		scrollSpy
	},
	props: {
		text: {
			type: String
		},
		index: {
			type: Number
		},
		className: {
			type: String
		}
	},
	methods: {
		handleClick: function(e) {
			let targetDiv = document.getElementById(`toc-content-${this.index}`)
				.offsetTop;
			setTimeout(() => {
				if (targetDiv) {
					window.scrollTo({
						top: targetDiv + 40
					});
				}
			}, 600);
		}
	}
};
</script>
